import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Image, Modal } from "react-bootstrap";
import SecureLS from "secure-ls";
// import "./More.css";
import { Link, useNavigate } from "react-router-dom";
import { IoChevronDown } from "react-icons/io5";

function More({ productBarcode, sku }) {
  const [products, setProducts] = useState([]);
  const baseUrl = "https://karstar.in";

  useEffect(() => {
    getRelatedProducts("na", "na");
  }, []);

  const getRelatedProducts = async (sessionId, username) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/client_api/More/index.php?barcode=${productBarcode}&ipadd=${sessionId}&email=${username}`
      );
      const data = response.data.data;
      setProducts(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const generateSlug = (name) => {
    return name.replace(/ /g, "-");
  };

  return (
    <div>
      <h5 className="text-black mb-3">Available Colors</h5>
      <ButtonToolbar className="mb-4">
        {products.map((item, index) => (
          <Link
            key={index}
            to={`/product/${generateSlug(item?.name)}`}
            className="rounded-5 bg-transparent border-0 p-0"
          >
            <img
              className="product-image me-2"
              src={item.images.replace("../../../../", baseUrl + "/")}
              style={{
                zIndex: -1,
                position: "relative",
                width: "4rem",
                aspectRatio: "1/1",
                objectFit: "cover",
                border: item.sku === sku ? "3px solid black" : "",
              }}
            />
          </Link>
        ))}
      </ButtonToolbar>
    </div>
  );
}

export default More;
